import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'
import { browserHistory } from 'react-router'
import Spinner from './../common/Spinner'
import moment from 'moment'
import momentLocalizer from 'react-widgets/lib/localizers/moment'
import yup from 'yup'
import Form from 'react-formal'
import types from 'react-formal-inputs'
import 'react-widgets/lib/less/react-widgets.less'

class UserEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            passwordSelected: false,
            loading: false
        }

        function samePassword() {
            let parent = this.parent
            return parent.password === parent.validation
        }

        function hasANumber() {
            let parent = this.parent
            if (parent.password.match(/\d+/g) === null) {
                return false
            } else {
                return true
            }
        }

        function hasAnUpperCaseLetter() {
            let parent = this.parent
            if (parent.password.toLowerCase() === parent.password) {
                return false
            } else {
                return true
            }
        }

        this.modelSchemaPassword = yup.object({
            passwords: yup.object({
                password: yup.string().required('Ingrese una contraseña').min(8, 'Debe tener minimo 8 caracteres').test('has-a-number', 'Debe contener al menos un numero', hasANumber).test('has-an-upper-case-letter', 'Debe contener al menos una letra mayuscula', hasAnUpperCaseLetter),
                validation: yup.string().required('Vuelva a ingresar su contraseña').min(8, 'Debe tener minimo 8 caracteres').test('passwords-match', 'Las contraseñas no coinciden', samePassword).test('has-a-number', 'Debe contener al menos un numero', hasANumber).test('has-an-upper-case-letter', 'Debe contener al menos una letra mayuscula', hasAnUpperCaseLetter)
            })
        })

        Form.addInputTypes(types)
        momentLocalizer(moment)
    }

    componentDidMount() {
        let self = this
        self.props.actions.userGetOne(self.props.params.appCodename, self.props.params.userId).then(res => {
            if (res.payload.data) {
                self.setState({ user: res.payload.data })
            }
        })
    }

    goBack() {
        browserHistory.go(-1)
    }

    getModelSchema() {
        let self = this
        let modelSchema = yup.object({
            name: yup.object({
                first: yup.string().required('Ingrese su nombre').default(self.state.user.name && self.state.user.name.givenName || ''),
                last: yup.string().required('Ingrese su apellido').default(self.state.user.name && self.state.user.name.familyName || '')
            })
        })
        return modelSchema
    }

    userEditForm(formValues) {
        let self = this
        let name = formValues.name.first
        let surname = formValues.name.last
        let displayName = formValues.name.first + ' ' + formValues.name.last

        self.setState({ loading: true })

        self.props.actions.userEdit(self.props.params.appCodename, self.props.params.userId, {
            displayName: displayName,
            name: {
                familyName: surname,
                givenName: name
            }
        }).then(() => {
            self.setState({ loading: false })
            self.goBack()
        })
    }

    validatePassword(formValues) {
        let self = this
        let password = formValues.passwords.password

        self.props.actions.userChangePassword(self.props.params.userId, { password: password }).then(function() {
            alert('Se cambió la contraseña')
            return Promise.resolve()
        })
    }

    changePasswordState(value) {
        let self = this
        self.setState({passwordSelected: value})
    }

    render() {
        let self = this

        if (!self.state.user) {
            return (<Spinner/>)
        } else {
            let formContent
            let goToChangePassword
            if (self.props.profile.profile === 2000 || self.props.params.userId === 'me') {
                goToChangePassword = <button className="btn btn-primary" type="button" onClick={self.changePasswordState.bind(self, true)} disabled={ self.state.loading }>
                    Cambiar Contraseña  &nbsp;
                    <span className="fa fa-chevron-right"></span>
                </button>
            }

            if (!self.state.passwordSelected) {
                formContent = <div>
                    <Form schema={self.getModelSchema()} defaultValue={self.getModelSchema().default()} onSubmit={self.userEditForm.bind(self)}>
                        <div className='form-group col-md-6' key='nombre'>
                            <label>Nombre</label>
                            <Form.Field name='name.first' placeholder='Nombre' className='form-control'/>
                            <Form.Message for={'name.first'}/>
                        </div>
                        <div className='form-group col-md-6' key='apellido'>
                            <label>Apellido</label>
                            <Form.Field name='name.last' placeholder='Apellido' className='form-control'/>
                            <Form.Message for={'name.last'}/>
                        </div>
                        <div className="form-group col-md-12">
                            {goToChangePassword}
                            &nbsp;
                            <div className='pull-right'>
                                <Form.Button type='submit' className='btn btn-primary' disabled={ self.state.loading }>Guardar</Form.Button>
                                &nbsp;
                                <button className="btn btn-danger" type="button" onClick={self.goBack.bind(self)} disabled={ self.state.loading }>Cancelar</button>
                            </div>
                        </div>
                    </Form>
                </div>
            } else {
                formContent = <div>
                    <Form schema={self.modelSchemaPassword} defaultValue={self.modelSchemaPassword.default()} onSubmit={self.validatePassword.bind(self)}>
                        <div className='form-group col-md-6' key='password'>
                            <label>Contraseña</label>
                            <Form.Field key='password' name='passwords.password' placeholder='Contraseña123' className='form-control' type='password'/>
                            <Form.Message for={'passwords.password'}/>
                        </div>
                        <div className='form-group col-md-6' key='validation'>
                            <label>Validacion</label>
                            <Form.Field key='validation' name='passwords.validation' placeholder='Contraseña123' className='form-control' type='password'/>
                            <Form.Message for={'passwords.validation'}/>
                        </div>
                        <div className="form-group col-md-12">
                            <div className='pull-right'>
                                <Form.Button type='submit' className='btn btn-primary' disabled={ self.state.loading }>Guardar</Form.Button>
                                &nbsp;
                                <button className="btn btn-danger" type="button" onClick={self.changePasswordState.bind(self, false)} disabled={ self.state.loading }>Cancelar</button>
                            </div>
                        </div>
                    </Form>
                </div>
            }

            return (
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <h1 className="page-header">{(self.state.passwordSelected) ? 'Cambiar Contraseña' : 'Editar Usuario'}</h1>
                        </div>
                    </div>
                    <div className="row">
                        {formContent}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        profile: state.profile
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(UserEdit)



// WEBPACK FOOTER //
// ./components/UserEdit/index.js